import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { baseInstrumentSchema } from './shared/base.schema';
export const equitySchema = baseInstrumentSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.Equity),
    isin: z.string().length(12, 'Must be exactly 12 characters long.'),
    currency_id: z.number().int(),
    country_id: z.number().int(),
    counterparty_id: z.number().int(),
    bbg_ticker: z.string().min(1),
    company_name: z.string().min(1),
    description: z.string().min(1),
});
